export type AuditInvalidFieldTabKey = 'basics' | 'responsibles' | 'files';

export const AUDIT_INVALID_FIELD_TAB_BY_FIELD: Record<string, AuditInvalidFieldTabKey> = {
  assessmentCoordinator: 'responsibles',
  legalUnitResponsibles: 'responsibles',
  otherResponsibles: 'responsibles',
  fileLinkId: 'files'
};
